import { get, post } from "../../httpService";

export const saveCorrectPrediction = (a) => post(`/generic-astro-rules/${a.ruleId}/users/${a.userId}/agree`);
export const saveInCorrectPrediction = (a) => post(`/generic-astro-rules/${a.ruleId}/users/${a.userId}/disagree`);
export const saveMayBePrediction = (a) => post(`/generic-astro-rules/${a.ruleId}/users/${a.userId}/mayBe`);
export const getAllRules = () => get(`/generic-astro-rules`);

export const saveAstroRule =rule => post(`/generic-astro-rules`, rule);